export const HEADER_PINNED = "HEADER_PINNED";
export const HEADER_UNPINNED = "HEADER_UNPINNED";
